import React from "react";
import classnames from "classnames";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import styles from "./scroll-to-bottom-button.module.scss";

export const ScrollToBottomButton: React.FC<{
  showScrollToBottom: boolean;
  className?: string;
  scrollToBottomRef: React.RefObject<{ scrollBottom: () => void } | null>;
}> = ({ showScrollToBottom, className, scrollToBottomRef }) => {
  return (
    <div className={classnames(styles.scrollToBottomButtonContainer, { [styles.scrollToBottomButtonContainerShow]: showScrollToBottom }, className)}>
      <div
        data-testid="scroll-to-bottom-button"
        onClick={() => {
          scrollToBottomRef.current?.scrollBottom();
        }}
        className={styles.scrollToBottomButton}
      >
        <SvgV2 width={12} height={9} iconName={"arrow_down"} />
      </div>
    </div>
  );
};
